import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { logger } from '@adornis/base/logging.js';

@Entity()
export class Account extends MongoEntity {
  static override _class = 'Account';
  static override _collectionName = 'accounts';

  // System fields
  @Field(() => String) accountID: Maybe<string>;
  @Field(() => String) rowChecksum: Maybe<string>;
  @Field(() => Date) modifiedOn: Maybe<Date>;

  // Business fields
  @Field(() => String) accountName: Maybe<string>;
  @Field(() => String) address1City: Maybe<string>;
  @Field(() => String) address1Street1: Maybe<string>;
  @Field(() => String) address1ZipPostalCode: Maybe<string>;
  @Field(() => String) address1AddressType: Maybe<string>;
  @Field(() => String) accountNumber: Maybe<string>; // Could be Int if always numeric
  @Field(() => String) growth: Maybe<string>; // Could be Int/Float if always numeric
  @Field(() => String) salesArea: Maybe<string>;
  @Field(() => String) owner: Maybe<string>;
  @Field(() => String) website: Maybe<string>;
  @Field(() => String) address1Country: Maybe<string>;
  @Field(() => String) industry: Maybe<string>;
  @Field(() => String) status: Maybe<string>;
}
